// ======================================================================
// File Name       : UsageSettingLiveUtils
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import React from 'react';
import { DEFAULT_DATE_FORMAT_SHORT_DETAIL } from '../constants/index';
import { SELECT_BOX_DATA } from '../constants/SelectBoxData';
import { LIVE_RECORDING_PERMISSION, LIVE_RECORDING_STATUS } from '../constants/UsageSettingLiveConstant';
import { parseDateForDetail } from '../utils/index';

export function convertLiveFormatType(liveFormat) {
  const check = parseInt(liveFormat, 10);
  if (isNaN(check)) {
    return '';
  }
  const index = SELECT_BOX_DATA.LIVE_FORMAT_SELECT.findIndex(format => format.value === check);
  if (index < 0) {
    return '';
  }
  return SELECT_BOX_DATA.LIVE_FORMAT_SELECT[index].name || '';
}

export function convertLiveRecordingPermission(liveEnableRecording) {
  const check = parseInt(liveEnableRecording, 10);
  if (isNaN(check)) {
    return '';
  }
  const index = LIVE_RECORDING_PERMISSION.findIndex(format => format.value === check);
  if (index < 0) {
    return '';
  }
  return LIVE_RECORDING_PERMISSION[index].name || '';
}

export function getLiveStartTime(liveStartFrom, liveStartTo) {
  if (!liveStartFrom || !liveStartTo) {
    return '';
  }
  return `${moment(liveStartFrom).format(DEFAULT_DATE_FORMAT_SHORT_DETAIL)} ～ ${moment(
    liveStartTo,
  ).format('HH:mm')}`;
}

export function getLiveStartTimeDiv(liveStartFrom, liveStartTo) {
  if (!liveStartFrom || !liveStartTo) {
    return null;
  }
  return (
    <div>
      <div>{moment(liveStartFrom).format('YYYY/MM/DD')}</div>
      <div>
        {`${moment(liveStartFrom).format('HH:mm')} ～ ${moment(liveStartTo).format('HH:mm')}`}
      </div>
    </div>
  );
}

export function liveStartFromToFormat(data) {
  return (
    <div>
      <div style={{ float: 'right' }}>
        {parseDateForDetail(moment(data), DEFAULT_DATE_FORMAT_SHORT_DETAIL)}
      </div>
    </div>
  );
}

export function percentLiveProgressRatio(liveProgressRatio) {
  let data = '';
  if (liveProgressRatio < 50) {
    data = `不参加 (${liveProgressRatio}%)`;
  } else {
    data = `参加 (${liveProgressRatio}%)`;
  }
  return data;
}

export function convertLiveRecordingStatus(recordingStatus) {
  const check = parseInt(recordingStatus, 10);
  if (isNaN(check)) {
    return '';
  }
  const index = LIVE_RECORDING_STATUS.findIndex(format => format.value === check);
  if (index < 0) {
    return '';
  }
  return LIVE_RECORDING_STATUS[index].name || '';
}

export function convertBytesToMegaBytes(bytes) {
  if (isNaN(bytes)) {
    return '';
  }
  return Math.ceil((bytes / (1024 * 1024)));
}
